<template>
    <!-- 物流信息页面 -->
    <div class="li-wrapper">
        <div class="each-block">
            <div class="each-row mb35">
                <div class="right">{{ getCompany() }}</div>
            </div>
            <div class="each-row mb35">
                <div class="left">运单编号： {{ $route.query.no }}</div>
                <!-- <div class="right" v-text="$route.query.no"></div> -->
            </div>
        </div>
        <div class="divider"></div>
        <div class="li-wra" v-if="liData.length > 0" v-cloak>
            <div class="line" ref="line"></div>
            <div class="each-li" v-for="(item, index) in liData" :key="index">
                <div class="left">
                    <div class="date" :class="{ black: index === 0 }">
                        {{ item.time.split(" ")[0].slice(5) }}
                    </div>
                    <div class="time">{{ item.time.split(" ")[1] }}</div>
                </div>

                <div
                    class="dot"
                    :class="{ active: index === 0 }"
                    v-if="
                        (index > 0 && index < liData.length - 1) ||
                        (index === 0 && state != 3)
                    "
                ></div>
                <img class="icon" v-else :src="liIcon(index)" />

                <div
                    class="right"
                    :class="{
                        black: index === 0,
                        fz14: index === 0 || index === liData.length - 1,
                    }"
                >
                    {{ item.context }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import expresses from "@/js/express_code.js";
export default {
    name: "ApplyForRefund",
    components: {},
    props: {},
    data() {
        return {
            liData: [
                {
                    time: "2018-11-15 11:05:54",
                    ftime: "2018-11-15 11:05:54",
                    context: "本人-已签收",
                },
                {
                    time: "2018-11-15 11:05:54",
                    ftime: "2018-11-15 11:05:54",
                    context: "本人-已签收",
                },
                {
                    time: "2018-11-15 11:05:54",
                    ftime: "2018-11-15 11:05:54",
                    context: "本人-已签收",
                },
                {
                    time: "2018-11-15 11:05:54",
                    ftime: "2018-11-15 11:05:54",
                    context: "本人-已签收",
                },
                {
                    time: "2018-11-15 11:05:54",
                    ftime: "2018-11-15 11:05:54",
                    context: "本人-已签收",
                },
                {
                    time: "2018-11-15 11:05:54",
                    ftime: "2018-11-15 11:05:54",
                    context: "本人-已签收",
                },
            ],
            state: null,
            expresses,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.getData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        getData() {
            this.$axios
                .get(
                    `${window.API.user.express}/${this.$route.query.no}?token=${sessionStorage.token}&company=${this.$route.query.comcode}`
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.liData = data.data.info;
                        this.state = data.data.state;
                        this.$nextTick(() => {
                            let dot = document.querySelector(".dot");
                            this.$refs.line.style.left =
                                dot.getBoundingClientRect().left + 2 + "px";
                        });
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
        liIcon(index) {
            let len = this.liData.length;
            if (index === 0) {
                return API.ossUrl + "goods/png/selected.png";
            } else if (index === len - 1) {
                return API.ossUrl + "order/png/car-grey.png";
            }
        },
        getCompany() {
            let comcode = this.$route.query.comcode;
            if (!comcode) return "";
            let exp = this.expresses.filter(
                (express) => express.code === comcode
            );
            return exp ? exp[0].company : "";
        },
    },
};
</script>
<style scoped lang="scss">
.li-wrapper {
    background: $white;
    min-height: 100%;
    .divider {
        width: 100%;
        height: 0.213333rem;
        background: #f0f0f0;
    }
    .each-block {
        padding: 0.533333rem 0.4rem;
        background: $white;
        .each-row {
            display: flex;
            align-items: center;
            &:last-child {
                margin-bottom: 0px;
            }
            .left {
                color: #737373;
                font-size: 0.373333rem;
            }
            .right {
                font-size: 0.426667rem;
                color: #212121;
                .price {
                    color: $orange;
                    font-size: 0.186667rem;
                }
                .form-input /deep/ {
                    padding: 0px;
                    min-width: 4.533333rem;
                    input.van-field__control {
                        text-align: right;
                    }
                }
            }
        }

        .mb35 {
            margin-bottom: 0.466667rem;
        }
    }
    .li-wra {
        padding: 0.4rem;
        position: relative;
        .line {
            background: #ebebeb;
            width: 2px;
            height: 87%;
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
        }
        .each-li {
            display: flex;
            align-items: center;
            position: relative;
            &:not(:last-child) {
                margin-bottom: 0.613333rem;
            }
            .left {
                padding-right: 0.266667rem;
                .date {
                    color: #737373;
                    font-size: 0.32rem;
                    margin-bottom: 0.133333rem;
                }
                .time {
                    color: #737373;
                    font-size: 10px;
                }
            }
            .dot {
                width: 6px;
                height: 6px;
                background: #cccccc;
                border-radius: 50%;
                margin-left: 0.266667rem;
                margin-right: 0.266667rem;
                flex: none;
                &.active {
                    background: $orange;
                }
            }
            .icon {
                width: 0.666667rem;
                height: 0.666667rem;
            }
            .right {
                color: #737373;
                font-size: 0.32rem;
                padding-left: 0.266667rem;
                line-height: 1.7;
            }
            .black {
                color: #737373 !important;
            }
            .fz14 {
                font-size: 0.373333rem;
            }
        }
    }
}
</style>
